import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { KiteCard } from '@kite/react-kite';
import './MediaContacts.scss';

interface MediaContact {
    title: string;
    subtitle: string;
    desc: string;
    linkText: string;
    linkUrl: string;
    contact?: string;
}

export const MediaContacts = ({ node }) => {
    const mediaContacts = useStaticQuery(graphql`
        query contacts {
            allNodeMediaContact {
                nodes {
                    field_descriptions {
                        value
                    }
                    field_media_contact_coverage
                    field_media_contact_email
                    field_media_contact_name {
                        given
                        family
                    }
                    title
                    relationships {
                        field_media_contact_title {
                            name
                        }
                    }
                }
            }
            allNodeMediaCorporate {
                nodes {
                    field_media_contact_coverage
                    field_media_contact_email
                    title
                    relationships {
                        field_media_contact_title {
                            name
                        }
                    }
                }
            }
        }
    `);

    let title = ``;
    let data: MediaContact[] = [];

    if (node.field_listing.plugin_id === `views_block:media_contacts-block_2`) {
        title = `Communications Team`;
        data = mediaContacts.allNodeMediaCorporate.nodes.map((node) => ({
            title: node.title,
            subtitle: node.relationships.field_media_contact_title?.name,
            desc: node.field_media_contact_coverage?.[0],
            linkText: node.field_media_contact_email,
            linkUrl: `mailto:${node.field_media_contact_email}`,
        }));
        return (
            <section className="paragraph__media-contacts kite-container">
                <h2 className="typestack-title-3">{title}</h2>
                <div className="grid">
                    {data.map((item, idx) => (
                        <KiteCard className="team">
                            <h3>{item.title}</h3>

                            <div className="team__position">
                                <p>{item.subtitle}</p>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: item.desc,
                                    }}
                                />
                            </div>
                            <a href={item.linkUrl}>{item.linkText}</a>
                        </KiteCard>
                    ))}
                </div>
            </section>
        );
    } else if (
        node.field_listing.plugin_id === `views_block:media_contacts-block_1`
    ) {
        title = `Regional Communications`;
        data = mediaContacts.allNodeMediaContact.nodes.map((node) => {
            return {
                title: node.title,
                desc: node.field_descriptions?.value,
                subtitle: node.relationships.field_media_contact_title?.name,
                linkText: node.field_media_contact_email,
                linkUrl: `mailto:${node.field_media_contact_email}`,
                contact: `${node.field_media_contact_name.given} ${node.field_media_contact_name.family}`,
            };
        });

        return (
            <section className="paragraph__media-contacts kite-container">
                <h2 className="typestack-title-3">{title}</h2>
                <div className="grid">
                    {data.map((item, idx) => (
                        <KiteCard className="region">
                            <div className="region__location">
                                <h3>{item.title}</h3>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: item.desc,
                                    }}
                                />
                            </div>

                            <div className="region__contact">
                                <p>{item.contact}</p>
                                <p>{item.subtitle}</p>
                                <a href={item.linkUrl}>{item.linkText}</a>
                            </div>
                        </KiteCard>
                    ))}
                </div>
            </section>
        );
    }
};
